import './index.css';
import { useCallback, useState, useRef, useEffect } from 'react';
import { getIdsWithNoParentsInSameList } from './collection/treeCollectionHelper.js';
import './collection/treeCollection.js';

const useSelected = ({ value, maxSelected, strategy, collection, collapseToParentId, onChange, }) => {
    const getSelectedFromValue = useCallback(() => {
        let newValue = value.slice();
        if (maxSelected && newValue && newValue.length > maxSelected) {
            newValue = newValue.slice(0, maxSelected);
        }
        return strategy.add([], newValue);
    }, [value, maxSelected, strategy]);
    const [selected, setSelectedState] = useState(getSelectedFromValue);
    const firstRender = useRef(true);
    const setSelected = useCallback((id, isSelected) => {
        const ids = [id];
        const updatedSelected = isSelected ? strategy.add(selected, ids) : strategy.remove(selected, ids);
        const filteredUpdatedSelected = collapseToParentId
            ? getIdsWithNoParentsInSameList(collection, updatedSelected)
            : updatedSelected;
        if (maxSelected && filteredUpdatedSelected.length > maxSelected) {
            filteredUpdatedSelected.length = maxSelected;
        }
        onChange(filteredUpdatedSelected, id, isSelected);
    }, [strategy, selected, collection, collapseToParentId, onChange, maxSelected]);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        const selected = getSelectedFromValue();
        setSelectedState(selected);
    }, [getSelectedFromValue, firstRender]);
    return {
        selected,
        setSelected,
    };
};

export { useSelected };
//# sourceMappingURL=useSelected.js.map
